import { User } from "@supernova-studio/model";
import { DTOUserNotificationSettings } from "../notifications/settings";
import { DTOWorkspaceRole, DTOWorkspaceSeatType } from "./enums";
import { DTOWorkspace } from "./workspace";
import { z } from "zod";
//
// Read
//
export const DTOUserWorkspaceMembership = z.object({
    /** Workspace the user is a member of */
    workspace: DTOWorkspace,
    /** Assigned and stored role the user has in the workspace */
    role: DTOWorkspaceRole,
    /**  Role that determines actual permissions the user has in the workspace
     * E.g. this is different from the default role when editors are downgraded to viewers
     * when a workspace's subscription is downgraded to free tier
     */
    effectiveRole: DTOWorkspaceRole,
    /** Assigned and stored seat type the user has in the workspace */
    seatType: DTOWorkspaceSeatType,
    /** Seat type that determines actual permissions the user has in the workspace. */
    effectiveSeatType: DTOWorkspaceSeatType,
    isDeactivated: z.boolean(),
});
export const DTOWorkspaceMember = z.object({
    membershipId: z.string(),
    user: User,
    role: DTOWorkspaceRole,
    effectiveRole: DTOWorkspaceRole,
    seatType: DTOWorkspaceSeatType,
    effectiveSeatType: DTOWorkspaceSeatType,
    isDeactivated: z.boolean(),
    notificationSettings: DTOUserNotificationSettings,
});
export const DTOUserWorkspaceMembershipsResponse = z.object({
    membership: z.array(DTOUserWorkspaceMembership),
});
export const DTOWorkspaceMembersListResponse = z.object({
    members: z.array(DTOWorkspaceMember),
});
